import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { WeeklyHours } from "./HoursEditors";
import CustomerFormEditor from "./CustomerFormEditor";

const TYPES = [["text", "Testo breve"], ["textarea", "Testo lungo"], ["select", "Scelta da elenco"], ["number", "Numero"], ["checkbox", "Casella sì/no"], ["date", "Data"], ["tel", "Telefono"]];
const slug = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "").replace(/^(\d)/, "c_$1").slice(0, 40) || "campo";

export function FieldRow({ x, i, onChange, onRemove }) {
  const set = (k, v) => onChange({ ...x, [k]: v });
  return (
    <div className="rounded-md border border-slate-200 p-2 space-y-2" data-testid={`service-field-${i}`}>
      <div className="flex gap-2">
        <Input value={x.label} onChange={(e) => set("label", e.target.value)} placeholder="Domanda (es. Allergie)" className="h-8 text-xs flex-1" data-testid={`service-field-label-${i}`} />
        <Select value={x.type} onValueChange={(v) => set("type", v)}><SelectTrigger className="h-8 w-36 text-xs" data-testid={`service-field-type-${i}`}><SelectValue /></SelectTrigger>
          <SelectContent>{TYPES.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select>
        <Button type="button" size="icon" variant="ghost" className="h-8 w-8 text-slate-400 hover:text-red-600" onClick={onRemove} aria-label="Rimuovi campo" data-testid={`service-field-remove-${i}`}><Trash2 size={13} /></Button>
      </div>
      {x.type === "select" && <Input value={x.options_text ?? (x.options || []).join(", ")} onChange={(e) => set("options_text", e.target.value)} placeholder="Opzioni separate da virgola" className="h-8 text-xs" data-testid={`service-field-options-${i}`} />}
      <label className="flex items-center gap-2 text-xs text-slate-600"><Switch checked={!!x.required} onCheckedChange={(v) => set("required", v)} data-testid={`service-field-required-${i}`} />Obbligatorio</label>
    </div>);
}

export const fieldsOut = (rows) => {
  const seen = new Set();
  return rows.filter((x) => x.label.trim()).map((x) => {
    let key = x.key || slug(x.label);
    while (seen.has(key)) key = `${key}_2`.slice(0, 40);
    seen.add(key);
    const options = x.options_text != null ? x.options_text.split(",").map((o) => o.trim()).filter(Boolean) : x.options || [];
    return { key, label: x.label.trim(), type: x.type, required: !!x.required, options: x.type === "select" ? options : [], help: x.help || "" };
  });
};

export default function ServiceExtras({ f, set }) {
  return (
    <>
      <div className="rounded-lg border border-slate-200 p-3 space-y-2" data-testid="service-own-hours">
        <label className="flex items-center gap-2 text-sm text-slate-800"><Switch checked={f.own_hours} onCheckedChange={(v) => set("own_hours", v)} data-testid="service-own-hours-toggle" />Giorni e orari propri di questo servizio</label>
        <p className="text-[11px] text-slate-500">{f.own_hours ? "Prenotabile solo in questi orari e quando operatori/risorse sono liberi (le risorse condivise tra servizi non vengono mai prenotate due volte)." : "Usa gli orari degli operatori/risorse assegnati."}</p>
        {f.own_hours && <WeeklyHours value={f.week} onChange={(v) => set("week", v)} />}
      </div>
      <div className="space-y-2" data-testid="service-form-fields">
        <Label className="text-xs">Modulo cliente di questo servizio</Label>
        <CustomerFormEditor rows={f.form_rows || []} onChange={(v) => set("form_rows", v)} marketing={f.marketing_optin} onMarketing={(v) => set("marketing_optin", v)} />
      </div>
      <div><Label className="text-xs">Istruzioni mostrate prima della conferma (facoltative)</Label>
        <Textarea rows={2} value={f.instructions || ""} onChange={(e) => set("instructions", e.target.value)} placeholder="es. Arriva 10 minuti prima, porta un costume" data-testid="service-instructions" /></div>
    </>);
}
